/*
 * Small inline icon set used only by the home search card (tab pills,
 * search button, guest pill, check-in/check-out divider). Kept as plain
 * inline SVG React components (not .svg files) so there's no build-time
 * asset to manage - each one is tiny and self-contained.
 *
 * All icons share a 24x24 viewBox so they drop in at a consistent size
 * wherever they're used (set width/height via CSS on the wrapping element).
 */

export function PlaneIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
            <path d='M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' />
        </svg>
    );
}

export function HomeIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
            <path d='M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' />
        </svg>
    );
}

export function TentIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' {...props}>
            <polygon points='12,4 3,20 21,20' />
            <line x1='12' y1='4' x2='12' y2='20' />
        </svg>
    );
}

export function BookIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' {...props}>
            <rect x='3' y='4' width='18' height='16' rx='2' />
            <line x1='12' y1='4' x2='12' y2='20' />
        </svg>
    );
}

export function PersonIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
            <path d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' />
        </svg>
    );
}

export function SearchIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
            <path d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' />
        </svg>
    );
}

export function ArrowRightIcon(props) {
    return (
        <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' {...props}>
            <line x1='4' y1='12' x2='20' y2='12' />
            <polyline points='14,6 20,12 14,18' />
        </svg>
    );
}
